import { isNil, always, addIndex, pipe, map, prop, ifElse, prepend } from 'ramda';

export const getTimePeriodHours = ({ timePeriods }, index) =>
  ifElse(isNil, always(undefined), prop('hours'))(timePeriods[index]);

export const getStartTimePeriodObject = policy => ({
  moreThan: getTimePeriodHours(policy, 0),
  refund: policy.start,
});

export const mapPolicy = policy =>
  pipe(
    prop('timePeriods'),
    addIndex(map)(({ hours: lessThan, refund }, index) => ({
      lessThan,
      moreThan: getTimePeriodHours(policy, index + 1),
      refund,
    })),
    mappedPeriods => prepend(getStartTimePeriodObject(policy), mappedPeriods)
  )(policy);
